import React, {
    useCallback,
    useState,
    useEffect,
    useRef,
    useLayoutEffect,
} from "react";
import Carousel from "react-bootstrap/Carousel";
import OnImagesLoaded from "react-on-images-loaded";
import ModalBootstrap from "react-bootstrap/Modal";
import "../../common/jquery";
import PVideo from "../../common/PVideo";
import MessageItem from "./message-item";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MESSAGE_TYPE, ROLES, s3Link } from "../../utils/constants";
import { connect, useDispatch, useSelector } from "react-redux";
import {
    updateMsgOptionOpenR,
    updateMsgStatsR,
    reorderConvListR,
    reorderReceiveConvListR,
    setConvIndexR,
    updateShowImageModalR,
    updateShowBundleModalR,
    updateBundleIndexR,
    updateshowVideoModalR,
    updateImageModalSrcR,
    setMessages,
    setAlert,
    updateConvListR,
    addReadMessage,
    updateActiveConvR,
} from "../../../redux/actions";
import { isMobile } from "react-device-detect";
import useDidMountEffect from "../../utils/useDidMountEffect";
import CloseButton from "../../common/CloseButton";
import store from "../../../redux/reducers/reducer";
import pusher from "../../utils/pusher";
import { captureException, forceLoad } from "@sentry/react";
import { Spinner } from "react-bootstrap";
import Thumbprint from "../../common/Thumbprint";
import Avatar from "../../common/Avatar";
import videojs from "video.js";
import {
    setVideoPlayerId,
    setVideoPlayerIsPlaying,
} from "../../../redux/actions/videoPlayer";
import { Dialog, DialogContent } from "@mui/material";
import CreditCardForm from "../../common/CreditCardForm";

const settings = {
    interval: null,
    controls: true,
    indicators: false,
    slide: false,
    fade: false,
    // touch: false,
};

const ChatMessage = ({
    active,
    setActive,
    setShowLoader,
    msgOptionOpen,
    updateMsgOptionOpen,
    updateMsgStats,
    msgStats,
    stashSelected,
    reorderConvList,
    conv_list,
    convIndex,
    reorderReceiveConvList,
    setConvIndex,
    triggerScrollBottom,
    showImageModal,
    updateShowImageModal,
    imageModalSrc,
    showBundleModal,
    bundleIndex,
    bundleModalSrc,
    updateShowBundleModal,
    updateBundleIndex,
    showVideoModal,
    updateshowVideoModal,
    updateImageModalSrc,
    activeConv,
    showVerification,
    containerClass,
    fees,
    newLineCount,
    showPrice,
    newMessage = {},
    setNewMessage,
    newMessageObject,
    uuid,
    responseMessage,
    loadMessageTrigger,
    setMessages,
    setAlert,
    updateConvListR,
    addReadMessage,
    updateActiveConv,
    receiverDetails,
    isCurrentlyTyping,
    forceStopTypingIndicator,
    marginTop,
    videoIsPlaying,
    videoPlayerId,
}) => {
    const carouselRef = useRef();
    const cancelTokenSource = useRef();

    const videoRef = useRef();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [paidPpvs, setPaidPpvs] = useState([]);
    const [lastScroll, setLastScroll] = useState("");
    const [videoModalSrc, setVideoModalSrc] = useState("");
    const [imgSource, setImgSource] = useState("");
    const [messageEnd, setMessageEnd] = useState(false);
    const [scrollBottomTrigger, setScrollBottomTrigger] = useState(false);
    const [disableScroll, setDisableScroll] = useState(false);
    const [firstPageLoaded, setFirstPageLoaded] = useState(false); //is used to prevent scrolling bottom when there's no more messages and there's less than 16 messages
    const [pauseLoadMore, setpauseLoadMore] = useState(false); //used to disable auto trigger of load more when loading messages
    const [showMessages, setShowMessages] = useState(false);
    const [playVideoModal, setPlayVideoModal] = useState("false");
    const messagesEndRef = useRef(null);
    const [showVerificationError, setShowVerificationError] = useState(false);
    const [addCardStatus, setAddCardStatus] = useState(false);
    const [user, setUser] = useState({});
    const [processPPV, setProcessPPV] = useState(false);
    const [originalContentHeight, setOriginalContentHeight] = useState(0);
    const [hasSelectedStashImage, setHasSelectedStashImage] = useState(false);
    const [forceLoadMessage, setForceLoadMessage] = useState(0);

    const messages = useSelector((state) => state.message.messages);

    const customStylesVideo = {
        content: {},
        overlay: {
            zIndex: "2147483647",
        },
    };

    const cancelRequest = useCallback(() => {
        if (cancelTokenSource.current) {
            cancelTokenSource.current.cancel("Abort request");
        }
    }, [cancelTokenSource]);

    useDidMountEffect(() => {
        if (cancelTokenSource.current) {
            cancelRequest();
        }

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        cancelTokenSource.current = source;

        loadMessages(source, "first");
    }, [loadMessageTrigger]);

    const userInformation = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        if (stashSelected && stashSelected.length > 0) {
            setHasSelectedStashImage(true);
            const adjustedHeight = Math.abs(
                parseFloat($(".messenger-content").outerHeight()) -
                    parseFloat($(".messenger-controls").outerHeight()) -
                    $(".messenger-header").outerHeight() -
                    20
            );

            setContentHeight(adjustedHeight);

            setTimeout(() => {
                scrollToBottom();
            }, 500);
        }

        if (stashSelected == 0 && hasSelectedStashImage) {
            const adjustedHeight = Math.abs(
                parseFloat($(".messenger-content").outerHeight()) -
                    parseFloat($(".messenger-controls").outerHeight()) -
                    $(".messenger-header").outerHeight() -
                    20
            );
            setContentHeight(adjustedHeight);
        }
    }, [stashSelected]);

    useEffect(() => {
        if (showVerificationError) {
            setScrollBottomTrigger(!scrollBottomTrigger);
        }
    }, [showVerificationError]);

    useEffect(() => {
        if (Object.keys(responseMessage).length > 0) {
            const tmp = [...messages];
            const tmpMessages = tmp.map((t) => {
                if (t.uuid == responseMessage.uuid) {
                    t = responseMessage;
                }

                return t;
            });

            setMessages([...tmpMessages]);
        }
    }, [responseMessage]);

    useEffect(() => {
        setMessages([]); //clear messages when switching
        setFirstPageLoaded(false);

        if (activeConv) {
            if (cancelTokenSource.current) {
                cancelRequest();
            }

            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();
            cancelTokenSource.current = source;

            loadMessages(source, "first");
            setTimeout(() => {
                scrollToBottom();
            }, 300);
        }
        setMessageEnd(false);
    }, [activeConv, forceLoadMessage]);

    useEffect(() => {
        forceStopTypingIndicator();
    }, [activeConv]);

    useEffect(() => {
        if (messages.length < 16 && !firstPageLoaded) {
            //only scroll to bottom if first set of images or when switching conversation\
            scrollToBottom();
        }

        const node = $("#messages-cont");
        if (node && node.length > 0) {
            setLastScroll($("#messages-cont")[0].scrollHeight); //get last scroll position
        }
    }, [scrollBottomTrigger]);

    const showMessageBox = () => {
        if (messages.length < 16 && !firstPageLoaded) {
            scrollToBottom();
            setShowMessages(true);
        }
    };

    useDidMountEffect(() => {
        if (Object.keys(newMessageObject).length > 0) {
            setMessages([newMessageObject, ...messages]);
            setTimeout(() => {
                scrollToBottom();
            }, 300);
        }
    }, [newMessageObject]);

    const getFullMessage = async (messageId = null, senderId) => {
        await axios
            .get(`/api/messages/latest`, {
                params: {
                    sender_id: senderId,
                    message_id: messageId,
                },
            })
            .then((response) => {
                const messagesStore = store.getState().message.messages;
                let tmp = [...messagesStore];
                const index = tmp.findIndex((t) => t.id === messageId);

                // replace truncated or has media message
                if (index >= 0) {
                    tmp[index] = response.data;
                } else {
                    tmp.unshift(response.data);
                    setTimeout(() => {
                        scrollToBottom();
                    }, 400);
                }

                setMessages([...tmp]);
            })
            .catch((error) => {
                setAlert({
                    type: "error",
                    show: true,
                    body: "Failed to update a message. Please refresh the page",
                });
            });
    };

    useDidMountEffect(() => {
        const convList = store.getState().message.convList;
        if (messages.length > 0 && convList.length > 0) {
            const latestMessage = messages[0];
            const tmp = [...convList];

            // find conversation index to replace
            const index = tmp.findIndex(
                (conv) => conv.id == latestMessage.conversation_id
            );
            if (index >= 0) {
                tmp[index].latest_message = latestMessage;
                updateConvListR([...tmp]);

                setTimeout(() => {
                    // scrollToBottom();
                }, 300);
            }
        }
    }, [messages]);

    // pusher sequence
    const [puChannelName, setPuChannelName] = useState("");
    const [puChannel, setPuChannel] = useState("");
    const handleNewMessageEvent = (data) => {
        const senderId = parseInt(data.sender_id);
        const myId = parseInt(localStorage.getItem("loggedin_user"));
        const otherUserId = parseInt(localStorage.getItem("other_user"));
        const convList = store.getState().message.convList;
        const storeMessages = store.getState().message.messages;
        const activeConvIndex = store.getState().message.convIndex;

        setpauseLoadMore(true); // do not remove, prevents reload of entire message

        // check if new message is in conversation list
        const index = convList.findIndex(
            (conv) => conv.rec_id == senderId || conv.sender_id == senderId
        );
        if (index < 0) {
            // refetch sidebar conversation list
            // Event listener is in sidebar.js
            window.dispatchEvent(new Event("chatmessage/fetchConvs"));
        }

        if (activeConvIndex >= 0) {
            // get active conversation
            const activeConversation = convList[activeConvIndex];

            // check if active conversation is the sender
            if (
                activeConversation &&
                Object.keys(activeConversation).length > 0 &&
                otherUserId == senderId
            ) {
                getFullMessage(null, data.sender_id);
                window.dispatchEvent(new Event("chatmessage/fetchConvs"));
            } else {
                window.dispatchEvent(new Event("chatmessage/fetchConvs"));
            }
        }
    };

    const handleRemoveMessageEvent = (data) => {
        console.log("RemoveMessageEvent:", { data });
        const recId = parseInt(data.rec_id);
        const messageId = parseInt(data.id);
        const convId = data.conversation_id;
        const myId = parseInt(localStorage.getItem("loggedin_user"));
        const otherUserId = parseInt(localStorage.getItem("other_user"));
        const convList = store.getState().message.convList;
        const storeMessages = store.getState().message.messages;
        const activeConvIndex = store.getState().message.convIndex;
        const activeConvId = store.getState().message.activeConv;

        setpauseLoadMore(true); // do not remove, prevents reload of entire message

        // check if active conversation's id is the same as the remove message event's conversation id
        if (activeConvId == convId) {
            const tmp = [...storeMessages];
            const messageIndex = tmp.findIndex((message) => {
                return message.id == messageId;
            });

            if (messageIndex >= 0) {
                tmp.splice(messageIndex, 1);
                setMessages([...tmp]);
            }

            return;
        }

        window.dispatchEvent(new Event("chatmessage/fetchConvs"));
    };

    const handleReadMessagesEvent = (data) => {
        // set all unread messages to read
        const tmp = [...store.getState().message.messages];
        tmp.map((message) => {
            if (message.status == 0) {
                message.status = 1;
            }

            return message;
        });

        setMessages(tmp);

        console.log("🚀 ~ handleReadMessagesEvent ~ tmp:", tmp);
    };

    const handleMessagePpvPurchasedEvent = (data) => {
        const messageId = parseInt(data.msgId);
        const buyPrice = parseFloat(data.buyPrice);

        // set the msg_type to 2
        const tmp = [...store.getState().message.messages];
        const message = tmp.find((t) => t.id == messageId);

        if (message) {
            const index = tmp.findIndex((msg) => msg.id == message.id);

            message.msg_type = 2;
            message.buy_price = buyPrice;

            tmp.splice(index, 1, message);

            setMessages(tmp);
        }
    };

    const markMessageAsRead = (messageId) => {
        axios
            .patch(`/api/messages/${messageId}`, {
                action: "read",
            })
            .then(() => {})
            .catch((error) => {
                captureException(error);
            });
    };

    useEffect(() => {
        let isMounted = true;
        setVariableHeight($(".messenger-main").innerHeight());
        setOriginalContentHeight($(".messenger-main").innerHeight());

        const handleLoadMessage = () => {
            const conversations = store.getState().message.convList;
            const activeConversation = store.getState().message.activeConv;
            const tmpActiveConv = conversations.find(
                (conv) => conv.id == activeConversation
            );

            if (tmpActiveConv) {
                updateActiveConv(tmpActiveConv);
                setActive(tmpActiveConv.other_user);

                const isStashSidebar = store.getState().message.stashSidebar;
                if (isStashSidebar) {
                    setForceLoadMessage(
                        (forceLoadMessage) => forceLoadMessage + 1
                    );
                }
            }
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("chatmessage/loadMessages", handleLoadMessage);

        setPuChannelName(
            `private-chat-${localStorage.getItem("loggedin_user")}`
        );

        return () => {
            isMounted = false;
            window.removeEventListener("resize", handleResize);
            window.removeEventListener(
                "chatmessage/loadMessages",
                handleLoadMessage
            );
            const storeMessages = store.getState().message.messages;

            if (storeMessages.length === 0) {
                updateActiveConv(null);
            }
        };
    }, []);

    useEffect(() => {
        if (puChannelName) {
            setPuChannel(pusher.subscribe(puChannelName));
        }
    }, [puChannelName]);

    useEffect(() => {
        if (puChannel) {
            puChannel.bind("App\\Events\\MessageEvent", (d) => {
                handleNewMessageEvent(d);
            });
            puChannel.bind("App\\Events\\RemoveMessageEvent", (d) => {
                handleRemoveMessageEvent(d);
            });
            puChannel.bind("App\\Events\\ReadMessagesEvent", (d) => {
                handleReadMessagesEvent(d);
            });
            puChannel.bind("App\\Events\\MessagePpvPurchasedEvent", (d) => {
                handleMessagePpvPurchasedEvent(d);
            });
        }

        return () => {
            pusher.unsubscribe(puChannelName);
        };
    }, [puChannel]);

    const scrollToBottom = () => {
        const node = $(".messenger-main");
        if (node && node.length > 0) {
            $(".messenger-main").scrollTop(
                $(".messenger-main").prop("scrollHeight")
            );
        }
    };

    const changeScrollBottomCont = () => {
        setScrollBottomTrigger(!scrollBottomTrigger);
    };

    const handleVideoModal = () => {
        updateshowVideoModal(false);
        updateImageModalSrc("");
    };

    const openModalVideo = (video_src) => {
        setShowVideoModal(true);
        setVideoModalSrc(video_src);
        setPlayVideoModal(true);
    };

    const handleImageModal = () => {
        updateShowImageModal(false);
    };

    const handleBundleModal = () => {
        updateShowBundleModal(false);
    };

    const handleSelectBundle = (selectedIndex, e) => {
        updateBundleIndex(selectedIndex);
    };

    const Media = React.memo(function Media({
        media,
        sender_id,
        msg_type,
        msg_id,
        isStory = false,
    }) {
        if (media.type === "video" || media.type === "VIDEO") {
            let videoSrc = `${s3Link}/${media.file_path}`;
            let thumbSrc = `${s3Link}/${media.thumb_path}`;
            if (msg_type == MESSAGE_TYPE.STORY) {
                videoSrc = `${s3Link}/${media.file_path}`;
                thumbSrc = `${s3Link}/${media.thumb_path}`;
            }

            return (
                <div
                    className={`vid_thumb_cont vid_thumb_cont_m`}
                    onClick={() => openModalVideo(videoSrc)}
                >
                    <FontAwesomeIcon icon={["fas", "play-circle"]} />
                    <img
                        src={thumbSrc}
                        className="img-fluid"
                        threshold={1000}
                        onContextMenu={(e) => e.preventDefault()}
                        nosave="true"
                    />
                </div>
            );
        }

        if (media.type == "image" || media.type == "IMAGE") {
            let imgSrc = "";
            let effect = "";

            if (sender_id != localStorage.getItem("loggedin_user")) {
                if (paidPpvs.find((element) => element == msg_id)) {
                    imgSrc = `${s3Link}/${media.thumb_path}`;
                } else if (msg_type == 1) {
                    //unpaid has msg_type = 1 and status = 0
                    imgSrc = `${s3Link}/${media.blurred_path}`;
                } else {
                    imgSrc = `${s3Link}/${media.thumb_path}`;
                }
            }

            if (sender_id == localStorage.getItem("loggedin_user")) {
                if (media.thumb_path) imgSrc = `${s3Link}/${media.thumb_path}`;
                else imgSrc = `${s3Link}/${media.file_path}`;
                effect = "blur";
            }

            if (msg_type == MESSAGE_TYPE.STORY) {
                if (media.thumb_path) imgSrc = `${s3Link}/${media.thumb_path}`;
                else imgSrc = `${s3Link}/${media.file_path}`;
            }

            return (
                <img
                    src={imgSrc}
                    effect={effect}
                    className="img-fluid"
                    alt="Your browser wasn't able to download the media file, please refresh browser or check your internet is not having dropouts."
                    threshold={1000}
                    onContextMenu={(e) => e.preventDefault()}
                    nosave="true"
                />
            );
        }

        return "";
    });

    const messageScroll = () => {
        const wrappedElement = document.getElementById("messages-cont");
        if (wrappedElement.scrollTop == 0 && !pauseLoadMore && !messageEnd) {
            if (cancelTokenSource.current) {
                cancelRequest();
            }

            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();
            cancelTokenSource.current = source;

            loadMessages(source, "page");
        }
    };

    const loadMessages = async (source, isFirst) => {
        setShowMessages(false);
        setDisableScroll(true);
        setpauseLoadMore(true);
        if (messages.length == 0) {
            setLoading(true);
        } else {
            setDisableScroll(true);
        }

        try {
            await axios
                .post(
                    "/api/fetchmessages",
                    {
                        sender_id: localStorage.getItem("loggedin_user"),
                        msgs_loaded: isFirst == "first" ? 0 : messages.length,
                        rec_id: active,
                        conv_id: activeConv,
                    },
                    {
                        cancelToken: source.token,
                    }
                )
                .then(({ data }) => {
                    // window.dispatchEvent(new Event('chatmessage/fetchConvs'));
                    setLoading(false);
                    setpauseLoadMore(false);
                    if (isFirst == "first") {
                        setMessages([...data.data]);
                        setLastScroll("");
                    } else {
                        setFirstPageLoaded(true);
                        setMessages([...messages, ...data.data]);
                    }
                    if (data.data.length < 15) {
                        setMessageEnd(true);
                    }
                    setShowMessages(true);
                    setDisableScroll(false);
                    changeScrollBottomCont();

                    if (
                        lastScroll &&
                        isFirst != "first" &&
                        $("#messages-cont") &&
                        $("#messages-cont").length
                    ) {
                        document
                            .getElementById("messages-cont")
                            .scrollTo(
                                0,
                                $("#messages-cont")[0].scrollHeight - lastScroll
                            );
                    }

                    setTimeout(function () {
                        setpauseLoadMore(false);
                    }, 1500);
                });
        } catch (error) {
            console.error({ error });
            if (axios.isCancel(error)) {
                console.error("Request canceled: ", error.message);
            }
        }
    };

    const getOtherUserInformation = async () => {
        const otherUserId = conv_list[convIndex].other_user_id;
        await axios.get(`/api/users/${otherUserId}`).then((response) => {
            setUser(response.data);
        });
    };

    /*useEffect(() => {
        let mounted = true;
        if (paymentShow) {
            getOtherUserInformation();
        }

        return () => {
            return mounted = false;
        };
    }, [paymentShow]);*/

    useEffect(() => {
        let mounted = true;
        if (addCardStatus) {
            setProcessPPV(true);
            setUser({});
            setAddCardStatus(false);
        }
        return () => {
            return (mounted = false);
        };
    }, [addCardStatus]);

    const [contentHeight, setContentHeight] = useState("");
    const [defaultContentHeight, setDefaultContentHeight] = useState("");
    const [variableHeight, setVariableHeight] = useState(0);

    const handleResize = () => {
        setVariableHeight(window.innerHeight - 250);
    };

    useLayoutEffect(() => {
        setDefaultContentHeight(variableHeight);
        setContentHeight(variableHeight);
    }, [variableHeight]);

    useLayoutEffect(() => {
        if (newLineCount <= 6) {
            // 6 is max rows set for textarea to grow
            let multiplier = 16;

            if (isMobile) {
                multiplier = 18;
            }

            let hasImages = 0;

            if (stashSelected == 1) {
                hasImages = $(".ppv-images-cont").height();
            }

            setContentHeight(
                defaultContentHeight - newLineCount * multiplier - hasImages
            );
        }
    }, [newLineCount, contentHeight]);

    const removeMessage = (id) => {
        let tmp = [...messages];
        const index = tmp.findIndex((t) => t.id == id);
        if (index >= 0) {
            tmp.splice(index, 1);
            setMessages([...tmp]);
        }
    };

    const handleWindowResize = () => {
        const time = isMobile ? 1500 : 800;
        setTimeout(() => {
            if (document.querySelector(".messenger-content")) {
                const parentHeight =
                    document.querySelector(".messenger-content").clientHeight;
                const headerHeight = $(".messenger-header").outerHeight();
                const chatHeight = $(".messenger-controls").outerHeight();
                const height = parentHeight - (headerHeight + chatHeight + 30);
                if (parentHeight && height > 0) {
                    $("#messages-cont").css({
                        height: height,
                        "max-height": height,
                    });
                }
            }
        }, time);
    };

    useLayoutEffect(() => {
        handleWindowResize();

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    useEffect(() => {
        if (showVideoModal) {
            const handleContextmenu = (e) => {
                e.preventDefault();
            };

            document.addEventListener("contextmenu", handleContextmenu);

            return () => {
                document.removeEventListener("contextmenu", handleContextmenu);
            };
        }
    }, [showVideoModal]);

    const loadMessagesProp = (param) => {
        if (cancelTokenSource.current) {
            cancelRequest();
        }

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        cancelTokenSource.current = source;

        loadMessages(source, param);
    };

    const handleSlide = () => {
        if (videoIsPlaying === true && videoPlayerId !== null) {
            const player = videojs(videoPlayerId);
            player.pause();
            dispatch(setVideoPlayerId(null));
            dispatch(setVideoPlayerIsPlaying(false));
        }
    };

    useEffect(() => {
        if (isCurrentlyTyping) {
            setTimeout(() => {
                scrollToBottom();
            }, 800);
        }
    }, [isCurrentlyTyping]);

    return (
        <div
            className={`messenger-main chat-bx-wrp show ${
                disableScroll ? "disable-scroll" : ""
            } ${
                stashSelected && stashSelected.length > 0
                    ? " has-stash-selected"
                    : ""
            } ${
                stashSelected && stashSelected.length == 0 && showPrice
                    ? "no-stash-selected"
                    : ""
            }`}
            id="messages-cont"
            onScroll={messageScroll}
            ref={messagesEndRef}
            style={{
                height: contentHeight,
                marginTop: marginTop,
                display:
                    !showMessages && messages.length === 0 ? "flex" : "block",
                alignItems: "center",
            }}
        >
            <div className={`messenger-inside-cont show`}>
                <OnImagesLoaded
                    onLoaded={showMessageBox}
                    onTimeout={showMessageBox}
                >
                    {!showMessages && (
                        <div
                            className="d-flex justify-content-center my-2"
                            style={{
                                width: "100%",
                                zIndex: 1,
                            }}
                        >
                            <Spinner
                                variant="primary"
                                animation="border"
                                size="sm"
                            />
                        </div>
                    )}
                    {!activeConv && showMessages ? (
                        <div
                            className="no-active-conv-notification"
                            style={{
                                height: contentHeight,
                            }}
                        >
                            <p>Select any Conversation or send a New Message</p>
                        </div>
                    ) : (
                        [...messages].reverse().map((message) => {
                            return (
                                <MessageItem
                                    message={message}
                                    key={message.id}
                                    active={active}
                                    setShowVerificationError={
                                        setShowVerificationError
                                    }
                                    processPPV={processPPV}
                                    setProcessPPV={setProcessPPV}
                                    fees={fees}
                                    fetchMessages={loadMessagesProp}
                                    syncRemove={removeMessage}
                                    setMessages={setMessages}
                                    messages={messages}
                                />
                            );
                        })
                    )}
                    {isCurrentlyTyping && (
                        <div className="message-item-out message-item-out-textonly">
                            <div className="chatmessage um-message-item right_m reply-bx recive-msg">
                                <div className="user-img">
                                    <Avatar
                                        size="40"
                                        pu={{
                                            id: receiverDetails.id,
                                            profile_pic:
                                                receiverDetails.profile_pic,
                                        }}
                                        story={false}
                                    />
                                </div>
                                <div className="user-reply">
                                    <div
                                        className="user-cmnt msg-text-only"
                                        style={{ marginTop: "20px" }}
                                    >
                                        <div
                                            className="msg-file-cont p-msg has-message"
                                            style={{
                                                height: "35px",
                                                width: "70px",
                                            }}
                                        >
                                            <div className="msg-text-def msg-text-cont container-indicator">
                                                <div className="typing-indicator-animation">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </OnImagesLoaded>
            </div>

            <ModalBootstrap
                show={showVideoModal}
                onHide={handleVideoModal}
                style={customStylesVideo}
                className="videoCont-modal video-modal"
                centered
                size="lg"
                animation={false}
            >
                <ModalBootstrap.Body
                    style={{ backgroundColor: "transparent !important" }}
                >
                    <div
                        className={`${containerClass}`}
                        style={{ backgroundColor: "transparent !important" }}
                    >
                        <CloseButton
                            className="close"
                            onClick={handleVideoModal}
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "12px",
                            }}
                        />
                        <div
                            ref={videoRef}
                            style={{
                                backgroundColor: "transparent !important",
                            }}
                            className="chat-vid-cont pu-chat-vid-cont"
                            onContextMenu={(e) => e.preventDefault()}
                        >
                            <PVideo
                                video={`${s3Link}/${imageModalSrc}`}
                                thumb=""
                                autoplay={playVideoModal}
                            />
                        </div>
                    </div>
                </ModalBootstrap.Body>
            </ModalBootstrap>
            <ModalBootstrap
                show={showImageModal}
                onHide={handleImageModal}
                className="videoCont-modal"
                centered
                size="lg"
                animation={false}
            >
                <ModalBootstrap.Body>
                    <div className={`messenger-single-media`}>
                        <CloseButton
                            className="close"
                            onClick={handleImageModal}
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "12px",
                            }}
                        />
                        <div
                            className={`embed-responsive chat-vid-cont img-vid-cont embed-responsive-4by3 ${containerClass}-thumbprint`}
                        >
                            {
                                <div
                                    className={"messenger-thumbprint-container"}
                                >
                                    <Thumbprint />
                                </div>
                            }
                            <img
                                src={`${s3Link}/${imageModalSrc}`}
                                onContextMenu={(e) => e.preventDefault()}
                                nosave="true"
                            />
                        </div>
                    </div>
                </ModalBootstrap.Body>
            </ModalBootstrap>
            <ModalBootstrap
                show={showBundleModal}
                onHide={handleBundleModal}
                className="videoCont-modal bundleCont-modal"
                centered
                size="lg"
                animation={false}
            >
                <ModalBootstrap.Body>
                    <CloseButton
                        className="close"
                        onClick={handleBundleModal}
                        style={{
                            position: "absolute",
                            top: "12px",
                            right: "12px",
                        }}
                    />
                    <div className={containerClass}>
                        <Carousel
                            {...settings}
                            prevIcon={
                                <span
                                    aria-hidden="true"
                                    className="carousel-control-prev-icon"
                                />
                            }
                            nextIcon={
                                <span
                                    aria-hidden="true"
                                    className="carousel-control-next-icon"
                                />
                            }
                            ref={carouselRef}
                            activeIndex={bundleIndex}
                            onSelect={handleSelectBundle}
                            onSlide={handleSlide}
                        >
                            {bundleModalSrc.map((attach, index) => (
                                <Carousel.Item
                                    className="chat-bubble-items bundle-modal-cont"
                                    key={`chat-bubble-item-${index}`}
                                >
                                    {attach.type.toLowerCase() === "image" && (
                                        <div
                                            key={index}
                                            className="bundle-img-cont-popup"
                                        >
                                            <span
                                                className={`cust-fancybox custom-fancyboxmany`}
                                            >
                                                <div
                                                    className={`${containerClass}-thumbprint`}
                                                >
                                                    {userInformation.id !==
                                                        attach.pu_id && (
                                                        <div
                                                            className={
                                                                "messenger-thumbprint-container"
                                                            }
                                                        >
                                                            <Thumbprint />
                                                        </div>
                                                    )}
                                                    <img
                                                        src={`${s3Link}/${
                                                            attach.large_path
                                                                ? attach.large_path
                                                                : attach.file_path
                                                        }`}
                                                        alt="Your browser wasn't able to download the media file, please refresh browser or check your internet is not having dropouts."
                                                        onContextMenu={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        nosave="true"
                                                    />
                                                </div>
                                            </span>
                                        </div>
                                    )}
                                    {attach.type.toLowerCase() === "video" && (
                                        <div
                                            ref={videoRef}
                                            key={index}
                                            onContextMenu={(e) =>
                                                e.preventDefault()
                                            }
                                        >
                                            <span className="modal-video-cont">
                                                <PVideo
                                                    video={`${s3Link}/${attach.file_path}`}
                                                    thumb={`${s3Link}/${attach.thumb_path}`}
                                                />
                                            </span>
                                        </div>
                                    )}
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </div>
                    <div className="embed-responsive chat-vid-cont img-vid-cont embed-responsive-4by3">
                        <img
                            src={imgSource}
                            onContextMenu={(e) => e.preventDefault()}
                            nosave="true"
                            className="popup"
                        />
                    </div>
                </ModalBootstrap.Body>
            </ModalBootstrap>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        msgOptionOpen: state.message.msgOptionOpen,
        msgStats: state.message.msgStats,
        stashSelected: state.message.stashSelected,
        conv_list: state.message.convList,
        convIndex: state.message.convIndex,
        triggerScrollBottom: state.message.triggerScrollBottom,
        showImageModal: state.message.showImageModal,
        imageModalSrc: state.message.imageModalSrc,
        showBundleModal: state.message.showBundleModal,
        bundleModalSrc: state.message.bundleModalSrc,
        bundleIndex: state.message.bundleIndex,
        showVideoModal: state.message.showVideoModal,
        activeConv: state.message.activeConv,
        showVerification: state.message.showVerification,
        containerClass: state.message.containerClass,
        videoIsPlaying: state.videoPlayer.isPlaying,
        videoPlayerId: state.videoPlayer.videoId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateMsgOptionOpen: (msgOptionOpen) =>
            dispatch(updateMsgOptionOpenR(msgOptionOpen)),
        updateMsgStats: (msgStats) => dispatch(updateMsgStatsR(msgStats)),
        setConvIndex: (convIndex) => dispatch(setConvIndexR(convIndex)),
        reorderConvList: (convList, convIndex, newMsg, newTime) =>
            dispatch(reorderConvListR(convList, convIndex, newMsg, newTime)),
        reorderReceiveConvList: (
            convList,
            convIndex,
            newMsg,
            newTime,
            message
        ) =>
            dispatch(
                reorderReceiveConvListR(
                    convList,
                    convIndex,
                    newMsg,
                    newTime,
                    message
                )
            ),
        updateShowImageModal: (showImageModal) =>
            dispatch(updateShowImageModalR(showImageModal)),
        updateImageModalSrc: (imageModalSrc) =>
            dispatch(updateImageModalSrcR(imageModalSrc)),
        updateShowBundleModal: (showBundleModal) =>
            dispatch(updateShowBundleModalR(showBundleModal)),
        updateBundleIndex: (bundleIndex) =>
            dispatch(updateBundleIndexR(bundleIndex)),
        updateshowVideoModal: (showVideoModal) =>
            dispatch(updateshowVideoModalR(showVideoModal)),
        setMessages: (payload) => dispatch(setMessages(payload)),
        setAlert: (payload) => dispatch(setAlert(payload)),
        updateConvListR: (payload) => dispatch(updateConvListR(payload)),
        addReadMessage: (payload) => dispatch(addReadMessage(payload)),
        updateActiveConv: (activeConv) =>
            dispatch(updateActiveConvR(activeConv)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(React.memo(ChatMessage));
